import { Box } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { Article, getCurrentWorkTaskId, IMicros } from "@tm/models"
import { useMicro } from "@tm/morpheus"
import { useSelector } from "react-redux"
import { useEffect, useMemo, useRef, useState } from "react"
import { TmaHelper, useWindowSize } from "@tm/utils"
import { MainState } from "../../main"

export default function ActionsButtons() {
    const { translateText } = useLocalization()
    const { renderMicro } = useMicro<IMicros>()

    const { configuratorImage, rimItem, accessoryKitItem, tireItem, sensorItem, mountingEnabled, mountingItem } = useSelector((state: MainState) => ({
        configuratorImage: state.overview.configuratorImage,
        rimItem: state.overview.rimItem,
        accessoryKitItem: state.overview.accessoryKitItem,
        tireItem: state.overview.tireItem,
        sensorItem: state.overview.sensorItem,
        mountingEnabled: state.overview.mountingEnabled,
        mountingItem: state.overview.mountingItem,
    }))

    const articlesToAddToBasket = useMemo(() => {
        const items = [rimItem, accessoryKitItem, sensorItem, tireItem, mountingEnabled ? mountingItem : undefined].filter((x) => !!x) as Article[]
        return items.filter((article) => article.isSelected)
    }, [rimItem, accessoryKitItem, sensorItem, tireItem, mountingEnabled, mountingItem])

    const [width] = useWindowSize()
    const [addToBasketButtonWidth, setAddToBasketButtonWidth] = useState(0)
    const addToBasketWrapperRef = useRef<HTMLElement>(null)

    const isCompactAddToBasket = useMemo(() => {
        const wrapper = addToBasketWrapperRef.current
        if (!wrapper) {
            return false
        }

        return wrapper.offsetWidth - addToBasketButtonWidth < 10
    }, [width, addToBasketButtonWidth])

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const addToBasketButton = addToBasketWrapperRef.current?.querySelector(".addToBasketButton") as HTMLButtonElement | null

            if (addToBasketButton) {
                const buttonWidth = addToBasketButton.offsetWidth

                if (buttonWidth > addToBasketButtonWidth) {
                    setAddToBasketButtonWidth(buttonWidth)
                }

                observer.disconnect()
            }
        })

        if (addToBasketWrapperRef.current) {
            observer.observe(addToBasketWrapperRef.current, {
                childList: true,
                subtree: true,
            })
        }

        return () => observer.disconnect()
    }, [width, addToBasketButtonWidth])

    TmaHelper.Shared.ByArticleAndUniParts.SetSearchContext("wheels", "", getCurrentWorkTaskId())

    return (
        <Box height="100%" display="flex" flex="1" justifyContent="flex-end" ref={addToBasketWrapperRef}>
            <Box width={isCompactAddToBasket ? "100%" : undefined} maxWidth={isCompactAddToBasket ? "6em" : undefined}>
                {renderMicro!("basket", "add-to-basket", {
                    data: articlesToAddToBasket,
                    buttonText: isCompactAddToBasket ? "" : translateText(133),
                    disabled: !articlesToAddToBasket.length,
                    vehicleImageBase64: configuratorImage,
                    fullHeight: true,
                    fontSize: "1.125rem",
                    width: isCompactAddToBasket ? "100%" : undefined,
                    hideBadge: true,
                    hideQuantityField: true,
                })}
            </Box>
        </Box>
    )
}
